type Props = {
  imgUrl: string;
  text: string;
  onClick: () => void;
};

/**
 * A StartPageButton component
 * @param props
 */
const StartPageButton = (props: Props) => {
  return (
    <button className="StartPageButton" onClick={props.onClick}>
      <img src={props.imgUrl} alt="" />
      <span className="StartPageButton__label">{props.text}</span>
    </button>
  );
};

export default StartPageButton;
